"use strict";

var _toConsumableArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/toConsumableArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLog = exports.debug = exports.removeLogMutater = exports.removeLogListener = exports.prefixMutater = exports.addLogMutater = exports.addLogListener = exports.LogLevel = void 0;

var debug_1 = __importDefault(require("debug"));

exports.debug = debug_1.default;
/** The level of a log message */

var LogLevel;

(function (LogLevel) {
  LogLevel[LogLevel["Debug"] = 0] = "Debug";
  LogLevel[LogLevel["Warning"] = 1] = "Warning";
  LogLevel[LogLevel["Error"] = 2] = "Error";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {})); // Making this a global variable should get around having multiple instances of
// this package installed. They just all have to conform to the same namespace
// so any future changes should be backwards-compatible.


if (!global.logListeners) {
  global.logListeners = [];
}

if (!global.logMutaters) {
  global.logMutaters = [];
}
/**
 * Adds a new log listener.
 *
 * @remarks
 * This is used, for example, in the Sentry feature to manually create breadcrumbs for any
 * feature log messages (so we don't have to have the DEBUG environment variable enabled in
 * production environments).
 *
 * @param identifier - the identifier for the listener, used to remove it later.
 * @param callback - the listener callback, called when a message is sent to the logger.
 */


var addLogListener = function addLogListener(identifier, callback) {
  if (!global.logListeners.find(function (listener) {
    return listener.identifier === identifier;
  })) {
    global.logListeners.push({
      identifier: identifier,
      callback: callback
    });
  }
};

exports.addLogListener = addLogListener;
/**
 * Adds a new log mutater.
 *
 * @remarks
 * This is used, for example, in feature-server for tagging all Lambda logs with the
 * current API Gateway request ID, if available.
 *
 * @param identifier - the identifier for the mutater, used to remove it later.
 * @param callback - the mutater callback, called when a message is sent to the logger.
 */

var addLogMutater = function addLogMutater(identifier, callback) {
  if (!global.logMutaters.find(function (mutater) {
    return mutater.identifier === identifier;
  })) {
    global.logMutaters.push({
      identifier: identifier,
      callback: callback
    });
  }
};

exports.addLogMutater = addLogMutater;
/**
 * Creates a log mutater that prefixes all log entries.
 *
 * @param prefix - the prefix to add to the log entries
 * @returns the mutater callback to pass to addLogMutater()
 */

var prefixMutater = function prefixMutater(prefix) {
  return function (level, args) {
    if (typeof args[0] === 'string') {
      return ["".concat(prefix, "\t").concat(args[0])].concat(_toConsumableArray(args.slice(1)));
    } else {
      return [prefix].concat(_toConsumableArray(args));
    }
  };
};

exports.prefixMutater = prefixMutater;
/**
 * Removes an existing log listener.
 * @param identifier - the identifier of the listener
 */

var removeLogListener = function removeLogListener(identifier) {
  global.logListeners = global.logListeners.filter(function (listener) {
    return listener.identifier !== identifier;
  });
};

exports.removeLogListener = removeLogListener;
/**
 * Removes an existing log mutater.
 * @param identifier - the identifier of the mutater
 */

var removeLogMutater = function removeLogMutater(identifier) {
  global.logMutaters = global.logMutaters.filter(function (mutater) {
    return mutater.identifier !== identifier;
  });
};

exports.removeLogMutater = removeLogMutater;

var callLogListeners = function callLogListeners(level, args) {
  var _iterator = _createForOfIteratorHelper(global.logListeners),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var listener = _step.value;
      listener.callback(level, args);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

var callLogMutaters = function callLogMutaters(level, args) {
  var runningArgs = args;

  var _iterator2 = _createForOfIteratorHelper(global.logMutaters),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var mutater = _step2.value;
      runningArgs = mutater.callback(level, runningArgs);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return runningArgs;
};
/**
 * Creates a new log instance.
 *
 * @remarks
 * Logging should never be done with `console.log`, and should always be done through this
 * `createLog` function. This way, we can control the visibility of messages in different
 * environments and can listen for messages to send them other places (perhaps a centralized
 * logging service).
 *
 * @example
 * ```ts
 * const { debug, error, warn } = createLog('feature-users')
 * debug('boom boom test message with a %s variable', 'cool')
 * ```
 *
 * @param namespace - the namespace of the log. Typically the name of the feature.
 */


var createLog = function createLog(namespace) {
  var originalDebug = (0, debug_1.default)(namespace);

  var debug = function debug(message) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var realArgs = callLogMutaters(LogLevel.Debug, [message].concat(args));
    originalDebug.apply(void 0, [realArgs[0]].concat(_toConsumableArray(realArgs.slice(1))));
    callLogListeners(LogLevel.Debug, realArgs);
  };

  var error = function error() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var realArgs = callLogMutaters(LogLevel.Error, args);
    console.error(realArgs);
    callLogListeners(LogLevel.Error, realArgs);
  };

  var warn = function warn() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var realArgs = callLogMutaters(LogLevel.Warning, args);
    console.warn(realArgs);
    callLogListeners(LogLevel.Warning, realArgs);
  };

  return {
    debug: debug,
    error: error,
    warn: warn
  };
};

exports.createLog = createLog;